export default __webpack_public_path__ + "static/media/fabricacion.ad8e4295.png";